import React from 'react';

import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ValidationForm, TextInput } from 'react-bootstrap4-form-validation';
import validator from 'validator';
import { useTranslation, Trans } from 'react-i18next';
import InfoTooltipComponent from '../../commons/infoTooltip/infoTooltipComponent';
import '../../assets/validatedCheckbox.css';
import './registerView.css';

import { Alert, Form, Button, Row, Col } from 'react-bootstrap';

import MainComponent from '../../commons/main/mainComponent';

const RegisterView = ({
    success,
    message,
    handleRegistration,
    handleInputChange,
}) => {
    const { t } = useTranslation();

    const registerForm = (
        <>
            <h3 className="text-center">{t('register.title')}</h3>
            <p>{t('register.introApplication')}</p>
            <p>{t('register.introFees')}</p>
            <p>{t('register.introApproval')}</p>
            <ValidationForm
                className="register-form"
                onSubmit={(e) => {
                    e.preventDefault();
                    handleRegistration(e);
                }}
            >
                <Row>
                    <Col md>
                        <Form.Group>
                            <Form.Label>{t('register.firstName')}</Form.Label>
                            <TextInput
                                name="firstName"
                                id="firstName"
                                errorMessage={{
                                    required: t('register.firstNameRequired'),
                                    pattern: t('register.firstNameInvalid'),
                                }}
                                required
                                pattern="[a-zA-Z\u00c0-\u017e- ]{2,20}$"
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col md>
                        <Form.Group>
                            <Form.Label>{t('register.lastName')}</Form.Label>
                            <TextInput
                                name="lastName"
                                id="lastName"
                                errorMessage={{
                                    required: t('register.lastNameRequired'),
                                    pattern: t('register.lastNameInvalid'),
                                }}
                                required
                                pattern="[a-zA-Z\u00c0-\u017e- ]{2,25}$"
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md>
                        <Form.Group>
                            <Form.Label>{t('register.utuAccount')}</Form.Label>
                            <TextInput
                                name="utuAccount"
                                id="utuAccount"
                                placeholder={t('register.utuAccountPlaceholder')}
                                errorMessage={{
                                    required: t('register.utuAccountRequired'),
                                    pattern: t('register.utuAccountInvalid'),
                                }}
                                pattern="[a-öA-Ö]{2,20}$"
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col md>
                        <Form.Group>
                            <Form.Label>{t('register.email')}</Form.Label>
                            <TextInput
                                name="email"
                                id="email"
                                errorMessage={{
                                    required: t('register.emailRequired'),
                                    validator: t('register.emailInvalid'),
                                }}
                                validator={validator.isEmail}
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md>
                        <Form.Group>
                            <Form.Label>{t('register.homeTown')}</Form.Label>
                            <TextInput
                                name="homeTown"
                                id="homeTown"
                                errorMessage={{
                                    required: t('register.homeTownRequired'),
                                    pattern: t('register.homeTownInvalid'),
                                }}
                                required
                                pattern="[a-zA-Z\u00c0-\u017e- ]{2,25}$"
                                onChange={handleInputChange}
                            />
                        </Form.Group>
                    </Col>
                    <Col md></Col>
                </Row>
                <Form.Group>
                    <Form.Check
                        inline
                        type="checkbox"
                        className="tyy-member"
                        name="tyyMember"
                        color="white"
                        style={{ color: 'white' }}
                        label={
                            <span style={{ color: 'white' }}>
                                {t('register.tyyMember')}{' '}
                                <InfoTooltipComponent
                                    text={t('common.tyyMemberInfo')}
                                />
                            </span>
                        }
                        onChange={handleInputChange}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Check
                        inline
                        type="checkbox"
                        name="acceptTerms"
                        className="accept-terms"
                        color="white"
                        id="acceptTerms"
                        style={{ color: 'white' }}
                        label={
                            <span style={{ color: 'white' }}>
                                <Trans
                                    i18nKey="register.acceptTerms"
                                    components={{
                                        privacyLink: (
                                            // The anchor text is injected
                                            // from the translation catalog
                                            // (register.acceptTerms), so the
                                            // lint rule cannot see it.
                                            // eslint-disable-next-line jsx-a11y/anchor-has-content
                                            <a href="https://digit.fi/viralliset/tietosuojaseloste" />
                                        ),
                                    }}
                                />
                            </span>
                        }
                        onChange={handleInputChange}
                    />
                </Form.Group>
                {message ? (
                    <Alert variant={!success ? 'danger' : 'success'}>
                        {t(message.key, message.params)}
                    </Alert>
                ) : null}
                <Button type="submit" variant="success">
                    <FontAwesomeIcon icon="sign-in-alt" />{' '}
                    {t('register.submit')}
                </Button>
            </ValidationForm>
            <hr />
            <div className="btm-links">
                <p>
                    <Link to="/">{t('common.back')}</Link>
                </p>
            </div>
        </>
    );

    const registrationComplete = (
        <>
            <h3 className="text-center">{t('register.completeTitle')}</h3>
            <p>{t('register.completeSummary')}</p>

            <p>{t('register.completeInstructions')}</p>
            <div className="btm-links">
                <p>
                    <Link to="/">{t('common.back')}</Link>
                </p>
            </div>
        </>
    );
    return (
        <MainComponent big="true">
            {success ? registrationComplete : registerForm}
        </MainComponent>
    );
};

export default RegisterView;
